import React from 'react';
import clsx from 'clsx';

import styles from './Navbar.module.scss';
import { StandardProps } from '../../types/common';

interface NavItemProps extends StandardProps {
  /**
   * Link to navigate to
   */
  href?: string;

  /**
   * Determines whether the item is active
   */
  isActive?: boolean;
}

export const NavItem = ({
  isActive = false,
  className,
  href,
  children,
}: NavItemProps): JSX.Element => {
  return (
    <li className={className}>
      <a
        href={href}
        className={clsx(styles['hds-nav__item'], {
          [styles.active]: isActive,
        })}
      >
        {children}
      </a>
    </li>
  );
};
